import React from 'react';
import './AllProjects.css'
import proj11A1 from '../../../images/project11/Screenshot (102).png'
import proj11A2 from '../../../images/project11/Screenshot (103).png'
import proj11A3 from '../../../images/project11/Screenshot (104).png'
import proj11A4 from '../../../images/project11/Screenshot (105).png'
import proj11A5 from '../../../images/project11/Screenshot (106).png'

import proj10A1 from '../../../images/project10/Screenshot (103).png'
import proj10A2 from '../../../images/project10/Screenshot (106).png'
import proj10A3 from '../../../images/project10/Screenshot (107).png'
import proj10A4 from '../../../images/project10/Screenshot (108).png'

import proj9A1 from '../../../images/Project9/Screenshot (108).png'
import proj9A2 from '../../../images/Project9/Screenshot (109).png'

import proj8A1 from '../../../images/project8/Screenshot (113).png'
import proj8A2 from '../../../images/project8/Screenshot (114).png'
import proj8A3 from '../../../images/project8/Screenshot (115).png'
import proj8A4 from '../../../images/project8/Screenshot (116).png'





const AllProjects = () => {
    return (
        <div className="container m-3">
           <h4>Some of my works</h4>
            <hr style={{width: '17%',height: '2px', color:'blue'}}/>
           <div className="projects align-middle">
           <div class="card" >
           <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
                <div class="carousel-indicators">
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                </div>
                <div class="carousel-inner">
                    <div class="carousel-item active">
                    <img src={proj11A1} class="d-block w-100" alt="..."/>
                    </div>
                    <div class="carousel-item">
                    <img src={proj11A2} class="d-block w-100" alt="..."/>
                    </div>
                    <div class="carousel-item">
                    <img src={proj11A3} class="d-block w-100" alt="..."/>
                    </div>
                    <div class="carousel-item">
                    <img src={proj11A4} class="d-block w-100" alt="..."/>
                    </div>
                    <div class="carousel-item">
                    <img src={proj11A5} class="d-block w-100" alt="..."/>
                    </div>
                </div>
                <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                </button>
                </div>
                <div class="card-body">
                    <p class="card-text">
                        <h6>Project Description:</h6>
                        <ul className="p-3 final-feature">
                            <li>Booking Management System Authenticated with firebase</li>
                            <li>Dynamic Review</li>
                            <li>Admin panel access for admins</li>
                            <li> Node js for Backend</li>
                            <li>Stripe Payment System</li>
                            <li>MongoDB Database</li>
                        </ul>
                        <div className="techs">
                            <button type="">React</button>
                            <button type="">React-Bootstrap</button>
                            <button type="">Node.js</button>
                            <button type="">MongoDB</button>
                            <button type="">Express js</button>
                            <button type="">Firebase</button>
                            </div>
                    </p>
                    <a className="view-button" href="https://travel1100-769d2.web.app/">Live</a>
                    <a className="view-button" href="https://github.com/Rafee1100/travel-agent">Front Code</a>
                    <a className="view-button" href="">Backend Code</a>
                </div>
                </div>
                <div class="card">
           <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
                <div class="carousel-indicators">
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                </div>
                <div class="carousel-inner">
                    <div class="carousel-item active">
                    <img src={proj10A1} class="d-block w-100" alt="..."/>
                    </div>
                    <div class="carousel-item">
                    <img src={proj10A2} class="d-block w-100" alt="..."/>
                    </div>
                    <div class="carousel-item">
                    <img src={proj10A3} class="d-block w-100" alt="..."/>
                    </div>
                    <div class="carousel-item">
                    <img src={proj10A4} class="d-block w-100" alt="..."/>
                    </div>
                </div>
                <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                </button>
                </div>
                <div class="card-body">
                    <p class="card-text">
                        <h6>Project Description:</h6>
                        <ul className="p-3 final-feature">
                            <li>E-Commerce Website built with React JS</li>
                            <li>Authentication Integrated with firebase</li>
                            <li>User buying history</li>
                            <li>Add New arrival by admin</li>
                            <li>Easy to Order</li>
                        </ul>
                        <div className="techs">
                            <button type="">React</button>
                            <button type="">firebase</button>
                            <button type="">Node.js</button>
                            <button type="">Express js</button>
                            <button type="">Material UI</button>
                            <button type="">MongoDB</button>
                            </div>
                    </p>
                    <a className="view-button" href="https://e-commerce-product-3b61a.web.app/">Live</a>
                    <a className="view-button" href="">Front Code</a>
                    <a className="view-button" href="">Backend Code</a>
                </div>
                </div>
                <div class="card">
           <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
                <div class="carousel-indicators">
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                </div>
                <div class="carousel-inner">
                    <div class="carousel-item active">
                    <img src={proj9A1} class="d-block w-100" alt="..."/>
                    </div>
                    <div class="carousel-item">
                    <img src={proj9A2} class="d-block w-100" alt="..."/>
                    </div>
                </div>
                <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                </button>
                </div>
                <div class="card-body">
                    <p class="card-text">
                        <h6>Project Description:</h6>
                        <ul className="p-3 final-feature">
                            <li>Cholo Jai is a Ride Sharing web app</li>
                            <li>Various kind of vehicles</li>
                            <li>Designation chose using google map</li>
                            <li>User Panel</li>
                            <li>User authentication</li>
                        </ul>
                        <h6>Technology Used:</h6>
                        <div className="techs">
                            <button type="">React</button>
                            <button type="">Bootstrap</button>
                            <button type="">firebase</button>
                            <button type="">CSS3</button>
                            </div>
                    </p>
                    <a className="view-button" href="https://cholo-jai-simple.web.app/">Live</a>
                    <a className="view-button" href="">Front Code</a>
                    <a className="view-button" href="">Backend Code</a>
                </div>
                </div>
                <div class="card">
           <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
                <div class="carousel-indicators">
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                </div>
                <div class="carousel-inner">
                    <div class="carousel-item active">
                    <img src={proj8A1} class="d-block w-100" alt="..."/>
                    </div>
                    <div class="carousel-item">
                    <img src={proj8A2} class="d-block w-100" alt="..."/>
                    </div>
                    <div class="carousel-item">
                    <img src={proj8A3} class="d-block w-100" alt="..."/>
                    </div>
                    <div class="carousel-item">
                    <img src={proj8A4} class="d-block w-100" alt="..."/>
                    </div>
                    
                </div>
                <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                </button>
                </div>
                <div class="card-body">
                    <p class="card-text">
                        <h5>Project Description:</h5>
                        <ul className="p-3 final-feature">
                            <li>ALl the premier league teams are sorted in the home page</li>
                            <li>By Clicking the explore one get to know more</li>
                            <li>Detail information about any club is there is description</li>
                            <li>Male/Female team toggle</li>
                        </ul>
                        <h6>Technology Used:</h6>
                        <div className="techs">
                            <button type="">React</button>
                            <button type="">Bootstrap</button>
                            <button type="">HTML</button>
                            <button type="">CSS3</button>
                            
                        </div>
                    </p>
                    <a className="view-button" href="https://football-adda-1100.netlify.app/">Live</a>
                    <a className="view-button" href="https://github.com/Rafee1100/react-team-management">Front Code</a>
                    <a className="view-button" href="">Backend Code</a>
                </div>
                </div>
           </div>
        </div>
    );
};

export default AllProjects;